import { Avatar, Box, Paper, Skeleton, Stack } from '@mui/material';

export default function LoadingSkeleton() {
  return (
    <Stack spacing={2}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Paper
          key={i}
          elevation={0}
          sx={{
            p: 2.5,
            borderRadius: 1,
            border: '1px solid #E4E7EC'
          }}
        >
          <Stack direction='row' spacing={2}>
            {/* Avatar */}
            <Skeleton variant='circular' width={50} height={50}>
              <Avatar />
            </Skeleton>

            <Box flex={1}>
              {/* Top Row */}
              <Stack direction='row' justifyContent='space-between' alignItems='center' mb={1}>
                <Stack direction='row' spacing={1} alignItems='center'>
                  <Skeleton variant='text' width={120} height={20} />
                  <Skeleton variant='text' width={80} height={20} />
                </Stack>

                <Stack direction='row' spacing={1}>
                  <Skeleton variant='circular' width={28} height={28} />
                  <Skeleton variant='circular' width={28} height={28} />
                </Stack>
              </Stack>

              {/* Title */}
              <Skeleton variant='text' width='40%' height={22} />

              {/* Description */}
              <Skeleton variant='text' width='90%' />
              <Skeleton variant='text' width='75%' />

              {/* Chips */}
              <Stack direction='row' spacing={1} mt={1}>
                <Skeleton variant='rounded' width={80} height={24} />
                <Skeleton variant='rounded' width={70} height={24} />
              </Stack>
            </Box>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
}
